export default __webpack_public_path__ + "static/media/GS.561c7f4d.svg";